export default __webpack_public_path__ + "static/media/Facebook-45.e661170f.svg";